document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".productTabbed_table--tabs--single");
    const tables = document.querySelectorAll(".productTabbed_table--table");
    const select = document.getElementById("productTabbed_tabSelector");

    function updateActiveTab(identifier) {
        // Remove active classes from all tabs and tables
        tabs.forEach(t => t.classList.remove("active_tab"));
        tables.forEach(table => table.classList.remove("active_table"));

        // Add active class to the corresponding tab (for desktop)
        const correspondingTab = document.querySelector(`.tab--${identifier}`);
        if (correspondingTab) {
            correspondingTab.classList.add("active_tab");
        }

        // Add active class to the corresponding table
        const correspondingTable = document.querySelector(`.table--${identifier}`);
        if (correspondingTable) {
            correspondingTable.classList.add("active_table");
        }
    }

    // Handle click event for desktop tabs
    tabs.forEach(tab => {
        tab.addEventListener("click", function () {
            const tabClass = Array.from(tab.classList).find(cls => cls.startsWith("tab--"));
            if (!tabClass) return;
            const identifier = tabClass.replace("tab--", "");
            updateActiveTab(identifier);
        });
    });

    // Handle change event for mobile select dropdown
    if (select) {
        select.addEventListener("change", function () {
            updateActiveTab(this.value.replace("table--", ""));
        });

        // Set the initial state based on the first selected option
        updateActiveTab(select.value.replace("table--", ""));
    }
});
